import React from "react";
import { FormattedMessage } from "react-intl";

/**
 * Legal text with associated links.
 * @returns {JSX.Element}
 * @constructor
 */
const CopyrightNotice = () => {
    return (
        <>
            <em>
                <FormattedMessage id="pageHeaderTitle" />
            </em>{" "}
            · <FormattedMessage id="createdBy" />{" "}
            <a href="https://www.explorewilder.com/en/about">Clement</a> ·{" "}
            <a href="https://git.explorewilder.com/clement/intentions/src/branch/main/LICENSE.pdf">
                Copyright
            </a>{" "}
            ·{" "}
            <a href="https://git.explorewilder.com/clement/intentions.git">
                <FormattedMessage id="source" />
            </a>
        </>
    );
};

export default CopyrightNotice;
